import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { useNavigate } from "react-router-dom";
import pages from "../../constants/pages";

const AppointmentErrorPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(pages.TrackAppointment.route);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      height="75vh"
      justifyContent="center"
      sx={{ p: 3, fontFamily: "Fira Sans, Montserrat, sans-serif" }}
    >
      {/* Error Icon */}
      <ErrorIcon sx={{ fontSize: 110, color: "red", mb: 6 }} />

      {/* Main Message */}
      <Typography variant="h5" fontWeight="bold" gutterBottom color="error">
        Sorry, this link is no longer active.
      </Typography>

      {/* Subtext */}
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{ maxWidth: 500, mb: 3 }}
      >
        The verification window for your journey has expired, and the seat has
        been reallocated. You won’t be able to continue with this link.
      </Typography>

      {/* Go Back Button */}
      {/* <Button
        variant="contained"
        color="error"
        onClick={handleGoBack}
        sx={{ borderRadius: "8px", textTransform: "none", px: 3 }}
      >
        Go Back
      </Button> */}
    </Box>
  );
};

export default AppointmentErrorPage;
